import { ref, watch } from 'vue'
export const useChecked = (list) => {
  const checkedAll = ref(false)
  const checked = ref([])
  const checkboxGroup = ref(null)
  const handleCheckedAllClick = () => {
    // 全部选择或取消
    console.log(checkboxGroup.value)
    checkboxGroup.value.toggleAll(checkedAll.value)
  }
  watch(checked, (val) => {
    // 监听选择值的变化设置全选状态
    if (val.length === list.value.length && list.value.length > 0) {
      console.log(111)
      checkedAll.value = true
    } else {
      console.log(222)
      checkedAll.value = false
    }
  })
  return {
    checkedAll,
    checked,
    checkboxGroup,
    handleCheckedAllClick
  }
}
